import { Button, Popover as PopoverBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Button)``;

export const Popover = styled(PopoverBase)``;
